"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarthShakerAbilityHandler = exports.EarthShakerActorAbilityFactory = exports.EarthShakerAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const CameraAction_1 = require("../../core/vfx/CameraAction");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class EarthShakerAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EarthShaker;
        this.__typeName = "EarthShaker";
    }
}
exports.EarthShakerAbilityArgs = EarthShakerAbilityArgs;
let EarthShakerActorAbilityFactory = class EarthShakerActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EarthShaker", "AllEnemies", 3);
    }
};
EarthShakerActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EarthShaker")
], EarthShakerActorAbilityFactory);
exports.EarthShakerActorAbilityFactory = EarthShakerActorAbilityFactory;
let EarthShakerAbilityHandler = class EarthShakerAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let didApplyCameraShake = false;
        container.applyMultiAttack({
            sequence,
            attackType: "melee",
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: 0,
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Nature", 70)
                ],
            })),
            onHit(sequence, { targetId }) {
                if (!didApplyCameraShake) {
                    sequence.push(core_1.CameraVfxStepArgs.Effect(new CameraAction_1.EffectVfxCameraAction("shake"), 600));
                    didApplyCameraShake = true;
                }
                if ((0, Random_1.randomPercent)() <= 25) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_2.StunEffectArgs()
                    });
                }
                if ((0, Random_1.randomPercent)() <= 50) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(5),
                        effect: new core_2.VulnerabilityEffectArgs((0, Random_1.random)(1, 5)),
                    });
                }
            }
        });
    }
};
EarthShakerAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EarthShaker)
], EarthShakerAbilityHandler);
exports.EarthShakerAbilityHandler = EarthShakerAbilityHandler;
